module.exports = __webpack_public_path__ + "img/5dad344a285615e5d4b0bf548379f9fa.5dad344a.png";